import useTranslator from "../../hooks/useTranslator";
import DownloadIcon from "../../assets/img/downloadIcon.svg";
import DocIcon from "../../assets/img/DocIcon.svg";
import VactorIcon3 from "../../assets/img/VactorIcon3.svg";
import CheckIcon0 from "../../assets/img/checkIcon02.svg";
import noticIcon from "../../assets/img/noticIcon.svg";
import DocIcon2 from "../../assets/img/DocIcon2.svg";
import Document from "../../assets/img/Document.svg";
import { useContext, useEffect, useState } from "react";
import constants from "../../Utils/constants";
import TenantContext from "../../context/tenant/TenantContext";
import moment from "moment";
import { formatToStandardDate, haveValue } from "../../helper/common";
import { Spinner } from "react-bootstrap";
import DocHistoryPopup from "../Property/DocHistoryPopup";
import DotIcon from "../../assets/img/DotIcon.svg";

const DetailsDocs = (props) => {
  const {
    user = {},
    setVerifiedDocs,
    setClaveDocs,
    forensicRawData,
    forensicAnalysis,
  } = props;
  const { _t } = useTranslator();
  const { fetchTenantDocs, getZipDocs } = useContext(TenantContext);
  const [tenantDocsDataOriginal, setTenantDocsDataOriginal] = useState([]);
  const [tenantDocsData, setTenantDocsData] = useState([]);
  const [tenantDocsHistory, setTenantDocsHistory] = useState({});
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [mandatoryDocsList, setMandatoryDocsList] = useState({});
  const [docHistoryPopup, setDocHistoryPopup] = useState(false);
  const [selectedTypeForHistory, setSelectedTypeForHistory] = useState(null);

  useEffect(() => {
    fetchFileData();
    selectMandatoryDocsList();
  }, [user]);

  const getKeyFactorByType = (keyFactorsArray, targetKey) => {
    return keyFactorsArray.find(
      (kf) => kf?.keyFactor?.toLowerCase() === targetKey.toLowerCase()
    );
  };

  useEffect(() => {
    const tempMap = new Map(); // Tracks 'clave' types
    const typeMap = new Map(); // Latest doc per type (strictly by type)
    const otherDocs = []; // Docs with 'others' source
    const publicHousingMap = new Map(); // Latest doc per type for public housing
    const docHistoryMap = new Map(); // All docs grouped by type for history
    const verifiedDocsMap = new Map();
    if (
      Array.isArray(tenantDocsDataOriginal) &&
      tenantDocsDataOriginal.length > 0
    ) {
      tenantDocsDataOriginal.forEach((doc) => {
        // Track 'clave' types
        if (doc?.from === "clave") {
          tempMap.set(doc.file_name, doc);
        }
        // Keep latest doc per unique type for main display, excluding 'others'
        if (doc?.from !== constants.others) {
          const existingDoc = typeMap.get(doc.type);

          if (
            !existingDoc ||
            new Date(doc.created_at) > new Date(existingDoc.created_at)
          ) {
            typeMap.set(doc.type, doc);
          }
        }
        // Collect 'others' docs
        if (doc?.from === "others") {
          otherDocs.push(doc);
        }
        // Keep latest doc per type for public housing docs
        if (doc?.from === "public_housing_docs") {
          const existing = publicHousingMap.get(doc.type);
          if (
            !existing ||
            new Date(doc.created_at) > new Date(existing.created_at)
          ) {
            publicHousingMap.set(doc.type, doc);
          }
        }
        // Build document history map by type
        if (!docHistoryMap.has(doc.type)) {
          docHistoryMap.set(doc.type, []);
        }
        docHistoryMap.get(doc.type).push(doc);
        //Get map of all Verified Docs
        if (!verifiedDocsMap.has(doc.type) && doc?.verified) {
          verifiedDocsMap.set(doc.file_name, doc);
        }
      });
      // Sort history arrays descending (latest first)
      docHistoryMap.forEach((docsArray) => {
        docsArray.sort(
          (a, b) => new Date(b.created_at) - new Date(a.created_at)
        );
      });
      // Prepare final list for main display
      const publicHousingDocsSorted = Array.from(
        publicHousingMap.values()
      ).sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
      const publicHousingTypes = new Set(
        publicHousingDocsSorted.map((doc) => doc.type)
      );
      const filteredTypeMapDocs = Array.from(typeMap.values()).filter(
        (doc) => !publicHousingTypes.has(doc.type)
      );
      const finalDocs = [
        ...otherDocs,
        ...publicHousingDocsSorted,
        ...filteredTypeMapDocs,
      ];
      // add uploaded for field in each doc
      const docListWithKeyFactor = {};
      (Array.isArray(forensicRawData) ? forensicRawData : []).forEach(
        (entry) => {
          const name = getKeyFactorByType(
            entry?.report?.keyFactors?.keyFactors,
            "Name"
          )?.value;
          if (name) {
            docListWithKeyFactor[name] = entry?.report?.documents_list || [];
          }
        }
      );

      finalDocs.forEach((doc) => {
        for (const [name, docs] of Object.entries(docListWithKeyFactor)) {
          const matched = docs.find((d) => {
            const extracted = d?.url?.split("/uploads/")[1];
            return extracted === doc.file_name;
          });

          if (matched) {
            doc.uploadedFor = name;
            break;
          }
        }
      });

      finalDocs.sort((a, b) => {
        const getPriority = (doc) => {
          if (doc?.from === "clave") return 0;
          if (doc?.verified === true) return 1;
          return 2;
        };

        return getPriority(a) - getPriority(b);
      });

      setTenantDocsData(finalDocs);
      setTenantDocsHistory(Object.fromEntries(docHistoryMap));
      setVerifiedDocs(verifiedDocsMap);
      setClaveDocs(tempMap);
    }
  }, [tenantDocsDataOriginal, forensicRawData]);

  const fetchFileData = async () => {
    if (haveValue(user)) {
      let userid = user?._id;
      const res = await fetchTenantDocs(userid);
      if (haveValue(res?.data?.success_res?.tenantDocs)) {
        setTenantDocsDataOriginal(res?.data?.success_res?.tenantDocs);
      }
    }
  };

  const selectMandatoryDocsList = () => {
    let employment_docs = {};
    if (user?.employment_status == "student") {
      employment_docs = constants.PROFESSION_DOCS.STUDENT_DOCS;
    } else if (user?.employment_status == "employed") {
      employment_docs = constants.PROFESSION_DOCS.EMPLOYED_DOCS;
    } else if (
      user?.employment_status == "self_employed" &&
      user?.is_freelancer
    ) {
      employment_docs = constants.PROFESSION_DOCS.FREELANCER_DOCS;
    } else if (
      user?.employment_status == "self_employed" &&
      !user?.is_freelancer
    ) {
      employment_docs = constants.PROFESSION_DOCS.SELF_EMPLOYED_DOCS;
    } else if (user?.employment_status == "retired") {
      employment_docs = constants.PROFESSION_DOCS.RETIRED_DOCS;
    } else if (user?.employment_status == "unemployed") {
      employment_docs = constants.PROFESSION_DOCS.UNEMPLOYED_DOCS;
    } else if (user?.employment_status == "public_servant") {
      employment_docs = constants.PROFESSION_DOCS.PUBLIC_SERVANT_DOCS;
    }
    setMandatoryDocsList(employment_docs);
  };

  const [showSpinner, setShowSpinner] = useState();

  const handleZipDown = () => {
    setShowSpinner(true);
    getZipDocs(user?._id)
      .then((res) => {
        const nodeJSBuffer = res.data.images.data;
        const uint8Array = new Uint8Array(nodeJSBuffer);

        // Convert Uint8Array to ArrayBuffer
        const arrayBuffer = uint8Array.buffer;

        // Create a Blob
        const blob = new Blob([arrayBuffer], {
          type: "application/octet-stream",
        });

        // Create a download link
        const a = document.createElement("a");
        a.href = URL.createObjectURL(blob);
        a.download = "documents.zip";

        document.body.appendChild(a);
        a.click();

        // Clean up
        document.body.removeChild(a);
        URL.revokeObjectURL(a.href);
        setShowSpinner(false);
      })
      .catch((err) => {
        setShowSpinner(false);
        console.log(err);
      });
  };

  const handlePreviewDocument = (url) => {
    window.open(url, "blank");
  };

  const missingDocs = Object.entries(mandatoryDocsList).filter(
    ([key]) => !(key in tenantDocsHistory)
  );

  return (
    <>
      <div className="col-6 custom-items--stretch">
        <div className="main_doc_div">
          <div className="d-flex align-items-center gap-4 justify-content-between BorderB">
            <div>
              <div className="d-flex align-items-center gap-2">
                <img src={Document} alt="Vector Icon" className="vactorImg" />
                <p className="docheader">{_t("documents")}</p>
                <p className="docnumber">
                  {Array.isArray(tenantDocsData) ? tenantDocsData.length : 0}
                </p>
              </div>
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              {showSpinner ? (
                <Spinner className="view_document_spinner" />
              ) : (
                <img
                  src={DownloadIcon}
                  alt="Vector Icon"
                  className="vactorImg2 downloadIcon cursor-pointer"
                  onClick={handleZipDown}
                />
              )}
            </div>
          </div>
          <div
            className="documents_fixed"
            style={{
              maxHeight:
                tenantDocsData?.length > 10 && missingDocs?.length === 0
                  ? "28.625vw"
                  : tenantDocsData?.length > 5 && missingDocs?.length === 0
                  ? "fit-content"
                  : "19.625vw",
            }}
          >
            {tenantDocsData.map((doc, index) => (
              <div
                key={index}
                className="d-flex align-items-center gap-4 justify-content-between BorderB2"
              >
                <div className="d-flex align-items-center gap-2">
                  <div className="docList">
                    <img
                      src={DocIcon}
                      alt="Vector Icon"
                      className="vactorImg2"
                    />
                  </div>
                  <div className="texReport_div">
                    <p
                      className="text-decoration-underline-hover cursor-pointer"
                      onClick={() => {
                        setDocHistoryPopup(false);
                        console.log("++", doc?.type);
                        setSelectedTypeForHistory(doc?.type ?? null);
                        setDocHistoryPopup(true);
                        setSelectedIndex(index);
                      }}
                    >
                      {_t(doc?.type, "", "fixed")}{" "}
                      {doc?.type === "Working life certificate" &&
                        haveValue(
                          forensicAnalysis?.["Work Life Certificate"]
                            ?.dataInJSON?.reportDate
                        ) &&
                        `(${formatToStandardDate(
                          forensicAnalysis?.["Work Life Certificate"]
                            ?.dataInJSON?.reportDate
                        )})`}
                    </p>
                    <p className="updatedlist">
                      {_t("uploadedOn")}{" "}
                      {moment(doc?.created_at).format("DD-MM-YYYY")}
                      {doc?.uploadedFor !== forensicAnalysis?.Name?.value && (
                        <span className="uploaddoc">
                          <img src={DotIcon} alt="Vector Icon" className="" />
                          {_t("uploadedFor")} {doc?.uploadedFor}
                        </span>
                      )}
                    </p>
                  </div>
                </div>
                <div className="d-flex align-items-center gap-2">
                  {doc?.from == "clave" && (
                    <div className="clickBtn2 d-flex align-items-center gap-2">
                      <p>Cl@ve</p>
                    </div>
                  )}
                  <div>
                    {doc?.verified && (
                      <img
                        src={CheckIcon0}
                        alt="Vector Icon"
                        className="vactorImg"
                      />
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {missingDocs.length > 0 && (
          <div className="main_doc_div mt-3 docomentclr">
            <div className="bgclolr_change">
              <div className="d-flex align-items-center gap-2 BorderB2">
                <img src={noticIcon} alt="Vector Icon" className="vactorImg2" />
                <p className="docheader">{_t("missingDocuments")}</p>
              </div>
              <div
                className="documents_fixed"
                style={{
                  maxHeight:
                    missingDocs?.length > 12 && tenantDocsData?.length === 0
                      ? "28.625vw"
                      : missingDocs?.length > 5 && tenantDocsData?.length === 0
                      ? "fit-content"
                      : "19.625vw",
                }}
              >
                {Object.entries(mandatoryDocsList).map(([key, value]) => {
                  if (!(key in tenantDocsHistory)) {
                    return (
                      <div
                        key={key}
                        className="d-flex align-items-center gap-4 justify-content-between BorderB2 py-2"
                      >
                        <div className="d-flex align-items-center gap-2">
                          <div className="docList docList2">
                            <img
                              src={DocIcon2}
                              alt="Vector Icon"
                              className="vactorImg2"
                            />
                          </div>
                          <div className="texReport_div">
                            <p>{_t(key, "", "fixed")}</p>
                          </div>
                        </div>
                      </div>
                    );
                  }
                })}
              </div>
            </div>
          </div>
        )}
        <DocHistoryPopup
          isOpen={docHistoryPopup}
          user={user}
          onClose={() => {
            setDocHistoryPopup(false);
            setSelectedIndex(0);
          }}
          docName={selectedTypeForHistory}
          allData={tenantDocsData}
          previousUploads={tenantDocsHistory?.[selectedTypeForHistory]}
          handlePreviewDocument={handlePreviewDocument}
          selectedIndex={selectedIndex}
        />
      </div>
    </>
  );
};
export default DetailsDocs;
